import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

const CENTRALISATEUR_HELP_MAPPING = {
  centralisateur: 'W.010.010',
  archives: 'W.090.020',
};

export const centralisateurHelpCodeResolver: ResolveFn<string | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const dateArchive = route.queryParamMap.get('dateArchive');
  if (dateArchive) {
    return CENTRALISATEUR_HELP_MAPPING.archives;
  }
  return CENTRALISATEUR_HELP_MAPPING.centralisateur;
};
